import styled from "styled-components";

interface StyledBoxResponsesProps {
  $isVisible: boolean;
}

export const StyledBoxResponses = styled.div<StyledBoxResponsesProps>`
  opacity: ${(props) => (props.$isVisible ? 1 : 0)};
  transform: ${(props) =>
    props.$isVisible ? "translateY(0)" : "translateY(20px)"};
  transition:
    opacity 0.6s ease-out,
    transform 0.6s ease-out;

  .box-responses-container {
    padding: 10px 20px 0;
    direction: rtl;
    min-height: 60vh;
  }
`;
